import React, {memo, useState} from "react";

import {Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import PropTypes from "prop-types";
// import {useDispatch} from "react-redux";

import Loader from "../../components/Loader";
import InputCreator from "../../components/Forms/components/InputCreator";
import ZeusButton from "../../components/Button";

const SlugFeedModal = (props) => {
  const {open, onSaveCallback} = props;
  const [minutes, setMinutes] = useState();

  //   const dispatch = useDispatch();

  return (
    <>
      <Modal unmountOnClose={true} isOpen={open} backdrop={"static"} size={"md"}>
        <Loader />
        <ModalHeader>SLUG FEED</ModalHeader>
        <ModalBody>
          <InputCreator
            type="decimal"
            value={minutes}
            label={"Minutes"}
            label_for
            large
            isRequired
            onChange={(e) => setMinutes(e.target.value)}
          />
        </ModalBody>
        <ModalFooter>
          <ZeusButton
            onClick={() => {
              onSaveCallback(minutes);
            }}
            withRadius
            disabled={!minutes}
          >
            SAVE
          </ZeusButton>
          <ZeusButton
            onClick={() => props.onClose()}
            data-cy={"cancel-btn"}
            className="info-small"
          >
            CANCEL
          </ZeusButton>
        </ModalFooter>
      </Modal>
    </>
  );
};

function areEqual(prevProps, nextProps) {
  return prevProps.open === nextProps.open;
}

SlugFeedModal.propTypes = {
  open: PropTypes.bool,
};
export default memo(SlugFeedModal, areEqual);
